export interface LoginRequest {
  email: string;
  identification: string;
  password: string;
  recaptchaToken?: string; // Hacer opcional porque el backend (Spring Boot) no lo requiere actualmente
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
  user: AuthUser;
}

export interface AuthUser {
  id: string;
  email: string;
  fullName: string;
  identification: string;
  photoUrl: string | null;
  jobTitle: string | null;
  roles: string[];
  profiles?: string[];
  permissions: string[];
  lastLogin: string | null;
}

// Permisos del sistema - se centralizan en la API
export const PERMISSIONS = {
  // Acceso a sistemas
  ADMIN_SYSTEM: 'admin:access',
  BRANCH_SYSTEM: 'branch:access',
  COMPLIANCE_SYSTEM: 'compliance:access',
  COURIER_SYSTEM: 'courier:access',
  SUPPORT_SYSTEM: 'support:access',

  // Módulos de estructura
  GROUPS_READ: 'groups:read',
  GROUPS_WRITE: 'groups:write',
  COMPANIES_READ: 'companies:read',
  COMPANIES_WRITE: 'companies:write',
  BRANCHES_READ: 'branches:read',
  BRANCHES_WRITE: 'branches:write',
  AGENTS_READ: 'agents:read',
  AGENTS_WRITE: 'agents:write',
  CORRESPONDENTS_READ: 'correspondents:read',
  CORRESPONDENTS_WRITE: 'correspondents:write',
  PRICING_READ: 'pricing:read',
  PRICING_WRITE: 'pricing:write',

  // Operaciones
  TRANSFERS_READ: 'transfers:read',
  TRANSFERS_WRITE: 'transfers:write',

  // Reportes
  REPORTS_READ: 'reports:read',
  REPORTS_EXPORT: 'reports:export',

  // Configuración
  SETTINGS_READ: 'settings:read',
  SETTINGS_WRITE: 'settings:write',
  USERS_READ: 'users:read',
  USERS_WRITE: 'users:write',
} as const;

// Obtener todos los permisos de admin (todos los del sistema)
export function getAdminPermissions(): string[] {
  return Object.values(PERMISSIONS);
}

export interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
}

// Re-export del wrapper estándar de respuesta del backend. La declaración real
// vive en `./api-response.ts` (es la única fuente de verdad del monorepo).
// Antes se declaraba acá pero estaba incompleta (`data: T` en vez de `data?: T`),
// lo cual mentía sobre el contrato del back que usa `@JsonInclude(NON_NULL)`.
export type { ApiResponse } from './api-response';
